import { Component } from '@wix/thunderbolt-becky-types'
import { pick } from 'lodash'

const getPageBackgroundComp = (component: Readonly<Component>) =>
	({
		id: `pageBackground_${component.id}`,
		type: 'Component',
		componentType: 'PageBackground',
		layout: {},
		parent: 'BACKGROUND_GROUP',
		styleId: '',
		metaData: { pageId: 'masterPage' },
		dataQuery: component.dataQuery,
		layoutQuery: component.layoutQuery,
	} as Component)

const getComboBoxInputListModal = (component: Readonly<Component>) => {
	const modalComp = pick(component, [
		'dataQuery',
		'propertyQuery',
		'layout',
		'layoutQuery',
		'skin',
		'styleId',
		'type',
	])

	return {
		...modalComp,
		id: `listModal_${component.id}`,
		componentType: 'ComboBoxInputListModal',
		parent: null,
		metaData: {},
	}
}

const getDatePickerCalendar = (component: Readonly<Component>) => {
	const portalComp = pick(component, [
		'dataQuery',
		'propertyQuery',
		'layout',
		'layoutQuery',
		'skin',
		'styleId',
		'type',
	])
	return {
		...portalComp,
		id: `portal-${component.id}`,
		componentType: 'DatePickerCalendar',
		parent: null,
		metaData: {},
	}
}

const getMenuContentComp = (component: Readonly<Component>): Component => {
	const portalComp = pick(component, ['skin', 'styleId', 'type', 'dataQuery'])
	return {
		...portalComp,
		id: `portal-${component.id}`,
		componentType: 'MenuContent',
		parent: null,
		layout: {},
		metaData: {},
	}
}

type AdditionalStructure = {
	[compId: string]: { [newCompId: string]: { get: Function; repeated?: boolean } }
}

export const additionalStructure: AdditionalStructure = {
	Page: { PageBackground: { get: getPageBackgroundComp } },
	ComboBoxInput: { ComboBoxInputListModal: { get: getComboBoxInputListModal } },
	DatePicker: { DatePickerCalendar: { get: getDatePickerCalendar, repeated: false } },
	Menu: { MenuContent: { get: getMenuContentComp, repeated: false } },
}
